(function() {
  'use strict';
  angular.module('app.LawyerProfile')
  .factory('LawyerProfileService', function($log, $http, $q) {
      return {
        fetchDataForSharingProfile: function(user_ID, firm_ID, job_ID) {
          var defer = $q.defer(),
              data = {
                user_resumes: null,
                firm: null,
                practices: null
              };

          $q.all([
            $http.post('/api/fetch-user-resumes',
              { id: user_ID },
              {'contentType': 'application/json'}
            ), $http.post('/api/admin/getFirm',
              { id: firm_ID },
              { 'contentType': 'application/json' }
            ), $http.post('/api/fetch-job-practices',
              { id: job_ID },
              { 'contentType': 'application/json' }
            )
          ]).then(
            function(responses){
              data.user_resumes = responses[0].data;
              data.firm = responses[1].data;
              data.practices = responses[2].data;
              defer.resolve(data);
            },
            function(error){
              defer.reject(error);
            }
          );

          return defer.promise;
        },
        fetchDataForSharingProfileSuggestedFirm: function(user_ID, firm_ID, job_ID) {
          var defer = $q.defer(),
              data = {
                user_resumes: null,
                firm: null,
                practices: null
              };

          $q.all([
            $http.post('/api/fetch-user-resumes',
              { id: user_ID },
              {'contentType': 'application/json'}
            ), $http.post('/api/admin/getFirm',
              { id: firm_ID },
              { 'contentType': 'application/json' }
            )
          ]).then(
            function(responses){
              data.user_resumes = responses[0].data;
              data.firm = responses[1].data;
              defer.resolve(data);
            },
            function(error){
              defer.reject(error);
            }
          );

          return defer.promise;
        },
        fetchAllFirms: function(){
          var defer = $q.defer();

          $http.post('/api/fetchFirms', {
            'contentType': 'application/json'
          }).then(function({data, status, headers, config}) {
            $log.info("****Admin fetch firms****");
            defer.resolve(data);
          },function (error){
             defer.reject(error);
          });

          return defer.promise;
        },
        applyForJob: function(jobData){
          var defer = $q.defer();

          $http.post('/api/apply-lawyer-job', jobData).then(function({data, status, headers, config}) {
            defer.resolve("success");
          },function (error){
            defer.reject(error);
          });

          return defer.promise;
        },
        applyForInhouseJob: function(jobData){
          var defer = $q.defer();

          $http.post('/api/apply-lawyer-inhouse-job', jobData).then(function({data, status, headers, config}) {
            defer.resolve("success");
          },function (error) {
            defer.reject(error);
          });

          return defer.promise;
        },
        applyForSuggestedFirm: function(jobData){
          var defer = $q.defer();
          $log.info("jobData",jobData);
          $http.post('/api/apply-lawyer-firm', jobData).then(function({data, status, headers, config}) {
            defer.resolve("success");
          },function (error){
            defer.reject(error);
          });

          return defer.promise;
        }
      };
    }
  );

}).call(this);



// WEBPACK FOOTER //
// ./scripts/lawyer-profile/LawyerProfileService.js